import "./components";

import "../components/page-header";
import "../components/layout";
import "../components/share";
import "../components/cipher/form";

import AdminLayout from "../web-sh/src/layouts";

import './css/index.scss';

export default AdminLayout;
